import { Directive, Input, HostListener,  Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appTrim]'
})
export class TrimDirective {

  @Input() ngModel;
  @Output() ngModelChange = new EventEmitter();

  constructor() {
  }


  @HostListener('change') onChange() {
    const trimmedName = this.removeExtraSpaces(this.ngModel);
    this.ngModelChange.emit(trimmedName);
  }

  removeExtraSpaces (name: string): string {
    if (!name) return;
    name = name.trim();
    if (name.indexOf(' ') > -1) {
      const nameArr = name.split('');
      for (let i = 0; i < nameArr.length; i++) {
        if (nameArr[i] === ' ' && nameArr[i - 1] === ' ') {
          nameArr.splice(i, 1);
          i = 0;
        }
      }
      return nameArr.join('');
    }
    return name;
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/shared/trim.directive/trim.directive.ts